<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      :z-index="10"
      @click-left="goableBack()"
      :title="$route.query.title"></van-nav-bar>
    <pdf v-for="item in numPages" :key="item" :page="item" :src="src"> </pdf>
  </div>
</template>

<script>
import { NavBar } from "vant"
import pdf from "vue-pdf-sign"
import CMapReaderFactory from "vue-pdf-sign/src/CMapReaderFactory.js"
export default {
  name: "lookPdfUrlFile",
  metaInfo: {
    title: "lookPdfUrlFile",
    meta: [
      { charset: "utf-8" },
      {
        name: "viewport",
        content:
          "width=width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes"
      }
    ]
  },

  data() {
    return {
      src: "",
      numPages: 0,
      currentPage: 1, // 当前页码
      pageCount: 0 // 总页码
    }
  },
  beforeMount() {
    this.src = pdf.createLoadingTask({
      url: this.$route.query.url,
      CMapReaderFactory
    })
    this.loadPdfHandler()
    this._dismissLoading()
  },
  methods: {
    loadPdfHandler() {
      this.src.promise.then((pdf) => {
        this.numPages = pdf.numPages
      })
    }
  },
  components: {
    pdf,
    [NavBar.name]: NavBar
  }
}
</script>
    
<style lang="less" scoped>
.content {
  padding: 0px;
}
.van-nav-bar {
  background: #fff;
  .van-nav-bar__title {
    color: @dark;
  }
  .van-icon {
    color: @dark !important;
  }
}
</style>
